import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { AdminApi } from 'src/api';
import useApiCall from 'src/hooks/use-api-call';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';

interface DeactivateUserConfirmModalProps {
  userId: string;
  userName: string;
  onSuccess: () => void;
  onClose: () => void;
}

const DeactivateUserConfirmModal: FunctionComponent<DeactivateUserConfirmModalProps> = ({
  onClose,
  onSuccess,
  userId,
  userName,
}) => {
  const { withApi, makeAuthenticatedApi } = useApiCall();

  const adminApi: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const onCtaClick = useCallback(() => {
    withApi(async () => {
      await adminApi.adminUsersPartialUpdate({
        id: userId,
        patchedAdminUserPartialUpdateRequest: { isActive: false },
      });

      onSuccess();
      onClose();
    });
  }, [userId, withApi, adminApi]);

  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="deactivateUserConfirmModal.title" />
      </ModalHeader>
      <ModalContent>
        <Translate name="deactivateUserConfirmModal.content" args={[<strong>{userName}</strong>]} />
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.cancel" />,
              size: 'large',
              onClick: () => onClose(),
            },
            {
              name: 'deactivate',
              variant: 'primary',
              content: <Translate name="deactivateUserConfirmModal.button" />,
              size: 'large',
              onClick: () => onCtaClick(),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeactivateUserConfirmModal;
